'use client';

import { createContext, useContext, useState } from 'react';
const LangContext = createContext<any>(undefined);
export function LangWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState('');
  return <LangContext.Provider value={{
    setLang,
    lang
  }} data-sentry-element="unknown" data-sentry-component="LangWrapper" data-sentry-source-file="langContext.tsx">
   {children}
  </LangContext.Provider>;
}
export function useLangContext() {
  return useContext(LangContext);
}